import { SplitContentCardConfig } from "@ui/context/component-config-context";

const splitContentCardConfig: SplitContentCardConfig = {
  contentBlockSize: "small",
  contentBlockVariation: "standard",
  lowerMetaFirstComponent: null,
  lowerMetaSecondComponent: null,
  lowerMetaThirdComponent: null,
  mediaVariationIconPlacement: "thumbnail",
  showBorder: false,
  showDek: false,
  showScore: false,
  upperMetaFirstComponent: "Category",
  upperMetaSecondComponent: null,
  upperMetaThirdComponent: null,
  componentContext: {
    fiveGridPattern: {
      contentBlockSize: "micro",
      upperMetaFirstComponent: null,
      lowerMetaFirstComponent: "ContentBlockByline",
    },
    fiveGridPackagePattern: {
      contentBlockSize: "small",
      contentBlockVariation: "special",
      upperMetaFirstComponent: null,
      lowerMetaFirstComponent: "ContentBlockAdvertiserFlag",
    },
    fiveGridGameGuidesPattern: {
      upperMetaFirstComponent: null,
      contentBlockSize: "small",
    },
    threeGridPattern: {
      contentBlockVariation: "special",
      upperMetaFirstComponent: null,
    },
    mapSection: {
      contentBlockSize: "small",
      contentBlockVariation: "standard",
      upperMetaFirstComponent: null,
    },
  },
};

export default splitContentCardConfig;
